// Anonymous identity stored in localStorage. Used to attribute history,
// feedback, and read-tracking to a guest user without requiring login.

const KEY = "recomendalibros:anon_id";

function uuid() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    // Fallback (non-crypto secure, sufficient for anon attribution)
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function getAnonId() {
    if (typeof window === "undefined") return "";
    try {
        let id = localStorage.getItem(KEY);
        if (!id || id.length < 8) {
            id = "anon-" + uuid();
            localStorage.setItem(KEY, id);
        }
        return id;
    } catch {
        return "";
    }
}
